import 'slick-carousel';
import '~/js/libs/swipeDetect';

$('.inspirations').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  dots: true,
  centerMode: true,
  variableWidth: true,
  infinite: true,
  focusOnSelect: true,
  nextArrow: '<a class="btn-next"><i class="icon-button-arrow-next"></i></a>',
  prevArrow: '<a class="btn-prev"><i class="icon-button-arrow-prev"></i></a>',
  customPaging: function(slider, i) {      
    return '<div class="custom-slick-dots" id=' + i + "></div>";
  },
  responsive: [
    {
      breakpoint: 2561,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        centerMode: false,
        variableWidth: true,
        infinite: true,
        focusOnSelect: true,
        centerPadding: 0
      }
    },
    {
      breakpoint: 1401,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
        centerMode: true,
        variableWidth: true,
        infinite: true,
        focusOnSelect: true,
        centerPadding: 0
      }
    },
    {
      breakpoint: 1024,
      settings: {
        arrows: true,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 2,
        slidesToScroll:1
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesToScroll:1
      }
    }
  ]
});


      